module.exports = __webpack_public_path__ + "img/Online.ba007725.png";